export default [
  { routeName: "trainingCoursesEdit", tabTitle: "Datos de la formación" },
  { routeName: "trainingCourses-trainingCourseSessions", tabTitle: "Sesiones" },
  { routeName: "trainingCourses-trainingCourseInscriptions", tabTitle: "Participantes" },
  { routeName: "trainingCourses-files", tabTitle: "Documentación" },
  { routeName: "trainingCourses-signedDocuments", tabTitle: "Documentos" },
  { routeName: "trainingCourses-clientNotices", tabTitle: "Avisos/Histórico" },
];
